import React from 'react';
import { RouteOverview as RouteOverviewType } from '../driverDashboardTypes';
import styles from './RouteOverview.module.css';

interface RouteOverviewProps {
  data: RouteOverviewType;
  onStartRoute?: () => void;
}

export const RouteOverview: React.FC<RouteOverviewProps> = ({ data, onStartRoute }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.headerIcon}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
            <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1z" />
          </svg>
        </span>
        <h3 className={styles.title}>{data.description}</h3>
      </div>

      <div className={styles.subRow}>
        <div className={styles.routeId}>
          <span className={styles.routeIdText}>Route {data.routeId}</span>
          <span className={styles.routeDate}>{data.date}</span>
        </div>
        <span className={styles.statusBadge}>✓ {data.status}</span>
      </div>

      <div className={styles.statsGrid}>
        {data.stats.map((stat) => (
          <div key={stat.id} className={styles.statBox}>
            <p className={styles.statValue}>{stat.value}</p>
            <p className={styles.statLabel}>{stat.label}</p>
          </div>
        ))}
      </div>

      <button className={styles.startButton} onClick={onStartRoute}>
        Start Route
      </button>
    </div>
  );
};
